<script setup>
import { computed, ref } from 'vue'
import { useAuthStore } from '~/store/auth.js'

definePageMeta({ auth: false, layout: 'basic' })

const email = ref('')
const isSubmitted = ref(false)

const authStore = useAuthStore()
const loading = computed(() => authStore.isLoading)

const handleSubmit = async () => {
  const mail = email.value.trim()
  if (!mail) return
  const ok = await authStore.requestPasswordReset(mail)
  if (ok) isSubmitted.value = true
}

const resetForm = () => {
  isSubmitted.value = false
  email.value = ''
}
</script>

<template>
  <div class="flex min-h-screen flex-col justify-center items-center px-6 py-12 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-sm">
      <h2 class="mt-8 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
        {{ isSubmitted ? 'E-mail odeslán' : 'Zapomenuté heslo' }}
      </h2>
      <p class="mt-2 text-center text-sm text-gray-600">
        {{ isSubmitted ? 'Zkontrolujte svoji e-mailovou schránku' : 'Zadejte e-mailovou adresu spojenou s Vaším účtem' }}
      </p>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-sm">
      <!-- Email submission form -->
      <form v-if="!isSubmitted" class="space-y-6" @submit.prevent="handleSubmit">
        <div>
          <label for="email" class="block text-sm font-medium leading-6 text-gray-900">E-mail</label>
          <div class="mt-2">
            <input
              id="email"
              v-model="email"
              name="email"
              type="email"
              autocomplete="email"
              required
              class="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300
                     placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
            />
          </div>
        </div>

        <div>
          <button
            type="submit"
            :disabled="loading"
            class="flex w-full justify-center rounded-md bg-primary px-3 py-1.5 text-sm font-semibold
                   leading-6 text-white shadow-sm hover:bg-primary-dark focus-visible:outline
                   focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary
                   disabled:bg-primary/60"
          >
            {{ loading ? 'Odesílám...' : 'Odeslat' }}
          </button>
        </div>
      </form>

      <!-- Success message after submission -->
      <div v-else class="text-center">
        <div class="mb-4 mt-6 flex justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-green-500" fill="none" viewBox="0 0 24 24"
               stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <p class="mb-6 text-gray-600">
          Nyní obdržíte e-mailem instrukce pro obnovení hesla.
          <br>Odkaz na reset hesla je platný jednu hodinu.
        </p>
        <button
          @click="resetForm"
          class="text-primary font-semibold hover:text-primary-dark"
        >
          Zkusit znovu s jiným e-mailem
        </button>
      </div>

      <p class="mt-10 text-center text-sm text-gray-500">
        <NuxtLink to="/" class="font-semibold leading-6 text-primary hover:text-primary-dark">
          Zpět na přihlášení
        </NuxtLink>
      </p>
    </div>
  </div>
</template>
